import { useEffect } from "react";

import { LangstonContentResponse } from "@/types/models";
import contentTypes from "@/view/constants/contentTypes";
import GeniusContent from "@/view/GeniusContent";
import { GenerationGeniusContent } from "@/view/GeniusContent/GeniusContent.interface";
import GeniusProviders from "@/view/GeniusContent/utils/GeniusProviders";
import useReadingTracker from "@/view/utils/useReadingTracker";
import { IBannerMode } from "./UnlevelledContent.interface";

export interface UnlevelledContentProps {
  bannerMode: IBannerMode;
  content: LangstonContentResponse | null | undefined;
}

const UnlevelledContent = ({ bannerMode, content }: UnlevelledContentProps) => {
  const isGenerationGenius =
    content?.content_type === contentTypes.GENERATION_GENIUS_VIDEO;

  const geniusContent = isGenerationGenius
    ? (content as GenerationGeniusContent)
    : null;

  useReadingTracker({ contentId: content?.id });

  useEffect(() => {
    if (geniusContent) {
      const { title } = geniusContent.data;
      document.title = title;
    }
  }, [geniusContent?.data.title]);

  if (!geniusContent) return null;

  return (
    <GeniusProviders
      contentId={geniusContent.id}
      contentType={geniusContent.content_type}
      isBannerModeActive={bannerMode.isBannerModeActive}
      isLiteContent={content?.data.is_lite || false}
      isPremiumContent={content?.data.is_premium || false}
    >
      <GeniusContent
        bannerMode={bannerMode}
        content={content as GenerationGeniusContent}
      />
    </GeniusProviders>
  );
};

export default UnlevelledContent;
